import { FormattedMessage, useIntl } from "react-intl";
import View from "components/utils/View";
import {
  SrContentHeader,
  SrContentWrapper,
  Typography,
} from "components/common";
import { ImgWithFallback } from "components";
import { MainItemsLayout } from "components/Layout";
import useStyles from "./expressChargeStyles";
import { SrButton } from "../../../../common";
import { Box, Grid, useMediaQuery } from "@material-ui/core";
import theme from "theme";
import { useEffect, useState } from "react";
import CardList from "assets/images/ExpressCharge/card-list.svg";

const ExpressChargeMainPage = ({ onButtonClick, isLoading }) => {
  const classes = useStyles();
  const intl = useIntl();

  const [phoneImageHeight, setPhoneImageHeight] = useState(566);
  const matchesSm = useMediaQuery(theme.breakpoints.only("sm"));
  const matchesXs = useMediaQuery(theme.breakpoints.only("xs"));

  useEffect(() => {
    if (matchesSm) {
      setPhoneImageHeight(420);
    } else if (matchesXs) {
      setPhoneImageHeight(330);
    } else {
      setPhoneImageHeight(566);
    }
  }, [matchesSm, matchesXs]);

  return (
    <View translateTitleKey="ecommerce.cobroExpress.heading">
      {isLoading && (
        <SrContentHeader
          title={intl.formatMessage({
            id: "ecommerce.cobroExpress.heading",
            defaultMessage: "Cobro Express",
          })}
        />
      )}
      <SrContentWrapper isLoading={isLoading}>
        <MainItemsLayout
          leftContent={
            <Box paddingLeft={theme.spacing(1)} marginBottom={theme.spacing(1)}>
              <Typography variant="h2" className={classes.paraHead}>
                <FormattedMessage
                  id="ecommerce.cobroExpress.heading"
                  defaultMessage="Cobro Express"
                />
              </Typography>
              <ul className={classes.list}>
                <li className={classes.listItem}>
                  <FormattedMessage
                    id="ecommerce.cobroExpress.ul.p1"
                    defaultMessage="Envía la liga de cobro por correo electrónico, redes sociales, mensajería instantánea o SMS."
                  />
                </li>
                <li className={classes.listItem}>
                  <FormattedMessage
                    id="ecommerce.cobroExpress.ul.p2"
                    defaultMessage="No necesitas página web."
                  />
                </li>
                <li className={classes.listItem}>
                  <FormattedMessage
                    id="ecommerce.cobroExpress.ul.p3"
                    defaultMessage="Tu cliente recibirá una liga en la que podrá colocar los datos de su tarjeta de manera segura."
                  />
                </li>
              </ul>
              <SrButton
                className={classes.apply}
                variant="contained"
                color="primary"
                onClick={() => onButtonClick()}
              >
                <FormattedMessage
                  id="common.apply"
                  defaultMessage="Solicitar"
                />
              </SrButton>
            </Box>
          }
          rightContent={
            <Grid container direction="column" alignItems="center">
              <ImgWithFallback
                src="/cobro-express/cobro-express.webp"
                fallback="/cobro-express/cobro-express.png"
                alt={intl.formatMessage({
                  id: "ecommerce.cobroExpress.whatIs.title",
                  defaultMessage: "¿Qué es un cobro express?",
                })}
                style={{
                  maxHeight: phoneImageHeight,
                  maxWidth: "100%",
                }}
              />
              <img
                className={classes.cardList}
                src={CardList}
                alt={intl.formatMessage({
                  id: "ecommerce.cobroExpress.whatIs.title",
                  defaultMessage: "¿Qué es un cobro express?",
                })}
              />
            </Grid>
          }
        />
      </SrContentWrapper>
    </View>
  );
};

export default ExpressChargeMainPage;
